import { Route, Routes } from 'react-router-dom';
import { HomeRoutes } from '../home/routes';
import { ScheduleRoutes } from '../schedule/routes';
import { SettingsRoutes } from '../settings/routes';
import { TemplateRoutes } from '../templates/routes';
import { NotFoundView } from '@/components/notfoundview';

export const AppRoutes = () => {
	return (
		<Routes>
			{HomeRoutes}
			{ScheduleRoutes}
			{SettingsRoutes}
			{TemplateRoutes}
			<Route
				path='*'
				element={<NotFoundView />}
			/>
		</Routes>
	);
};
